import React from 'react'
import Input from '../../../ui/forms/Input'

function HeaderOneCon({ data, index, inputChange }) {
    return (
        <div className="w-full space-y-3 mt-4">
            {/* Title */}
            <div className="flex items-center gap-3">
                <div className="w-32"> <p>Title</p></div>
                <div className="w-full">
                    <Input value={data?.title} onChange={(e) => inputChange(index, "title", e.target.value)} />
                </div>
            </div>
            {/* Link Name */}
            <div className="flex items-center gap-3">
                <div className="w-32">  <p>Link Name</p></div>
                <div className="w-full">
                    <Input value={data?.link_name} onChange={(e) => inputChange(index, "link_name", e.target.value)} />
                </div>
            </div>
            {/* Link URL */}
            <div className="flex items-center gap-3">
                <div className="w-32"> <p>Link URL</p></div>
                <div className="w-full">
                    <Input value={data?.link_url} onChange={(e) => inputChange(index, "link_url", e.target.value)} />
                </div>
            </div>
        </div>
    )
}

export default HeaderOneCon